import React, { forwardRef, Ref } from 'react';
import { Input as MuiInput, InputProps } from '@material-tailwind/react';
import clsx from 'clsx';

type Props = Partial<InputProps> & {
  ref?: Ref<HTMLInputElement>;
  inputClassName?: string;
  className?: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  type?: string;
  label?: string;
};

const Input = forwardRef<HTMLInputElement, Props>(
  ({ className, inputClassName, error, ...rest }, ref) => {
    return (
      <MuiInput
        ref={ref}
        error={error}
        className={clsx(
          error
            ? '!border-error-500 focus:!border-error-500'
            : '!border-grey-300 focus:!border-blue-500',
          '!text-base shadow-input bg-white text-grey-900',
          inputClassName
        )}
        containerProps={{ className: clsx('h-11', className) }}
        labelProps={{
          className: 'before:content-none after:content-none'
        }}
        {...rest}
      />
    );
  }
);

export default Input;
